import React, { useState } from 'react';
import styled from 'styled-components';

import { AddressBar, Counter, Marquee, Mast, StatusBar, xpCss, webCss } from 'lib/xp';

import pfp from 'assets/pfp.png';

// BUY $INTERNET — dark until launch. golive.ts flips LIVE and injects the CA
// + launchpad/chart URLs. Grep-gate: "TBA" must be gone before any public link.
// 2026-09-13: a 2001 shop page inside the XP frame (lib/xp `web` layer) — Kris: "colorful,
// Windows XP nostalgic, 2001 internet… same like you designed the casino."

const LIVE = true;
const CA = '0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c';
const BUY_URL = 'https://dexscreener.com/robinhood/0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c';
const CHART_URL = 'https://dexscreener.com/robinhood/0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c';

function openApp(name) {
  window.dispatchEvent(new CustomEvent('ic:open', { detail: name }));
}

export default function Buy() {
  const [copied, setCopied] = useState(false);
  function copyCa() {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CA).then(done, () => {});
    else {
      const el = document.getElementById('buy-ca');
      if (el && window.getSelection) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }

  return (
    <Div>
      <div className="xp__menubar">
        <button type="button">File</button>
        <button type="button">Favorites</button>
        <button type="button">Help</button>
        <span className="xp__menubar__brand">Internet Coin</span>
      </div>
      <AddressBar path="internetcoin.vip/buy.htm" />
      <div className="xp__client web web--orange">
        <Mast
          logo={pfp}
          kicker="the internet's own coin"
          title="BUY $INTERNET"
          right={
            <>
              <span className={`web__sticker${LIVE ? ' web__sticker--blink' : ' web__sticker--blue'}`}>{LIVE ? 'LIVE' : 'SOON'}</span>
              <span className="buy__visitor">
                you are visitor № <Counter value={88888} digits={7} />
              </span>
            </>
          }
        />
        <Marquee>
          ★ $INTERNET is LIVE on Robinhood Chain ★ quoted in tokenized Microsoft (MSFT) ★ 1.7% of every trade is airdropped to holders as MSFT ★ fair launch · no presale · no wallet tax ★ the dev earns nothing from trading ★
        </Marquee>

        <div className="web__body">
          <div className="web__cols">
            <div className="web__panel web__panel--navy">
              <div className="web__panel__t">Contract address</div>
              <div className="buy__ca">
                <span className="web__led" id="buy-ca">{CA}</span>
              </div>
              <div className="web__row buy__ca__row">
                <button type="button" className="web__btn web__btn--blue buy__small" onClick={copyCa}>
                  {copied ? 'copied ✓' : 'copy'}
                </button>
                <a href="/ca.txt" target="_blank" rel="noreferrer noopener">
                  verify at /ca.txt ↗
                </a>
              </div>
              <div className="web__note">
                ANY other address claiming to be Internet Coin is fake. The real one is on this page, in /ca.txt and in VERIFY.exe — nowhere else.
              </div>
            </div>
            <div className="web__panel web__panel--orange">
              <div className="web__panel__t">How to buy</div>
              <div className="web__step">
                <span className="web__step__n">1</span>
                <div>
                  <b>get tokenized MSFT</b>
                  $INTERNET is quoted in Microsoft stock, so you buy it with MSFT. <span className="buy__link" onClick={() => openApp('Network')}>Network Neighborhood</span> walks you through the chain.
                </div>
              </div>
              <div className="web__step">
                <span className="web__step__n">2</span>
                <div>
                  <b>press BUY</b>
                  the button below opens the pair on DexScreener. paste the contract address if you are asked.
                </div>
              </div>
              <div className="web__step">
                <span className="web__step__n">3</span>
                <div>
                  <b>hold, get paid</b>
                  every epoch pons airdrops holders their MSFT. the running total is in <span className="buy__link" onClick={() => openApp('Dividends')}>DIVIDENDS.exe</span>.
                </div>
              </div>
            </div>
          </div>

          <div className="web__center buy__cta">
            <a
              className={`web__btn web__btn--big${LIVE ? '' : ' web__btn--off'}`}
              href={LIVE && BUY_URL ? BUY_URL : undefined}
              aria-disabled={!LIVE}
              target="_blank"
              rel="noreferrer noopener"
            >
              ★ BUY NOW! ★
            </a>
            <a
              className={`web__btn web__btn--blue web__btn--big${LIVE ? '' : ' web__btn--off'}`}
              href={LIVE && CHART_URL ? CHART_URL : undefined}
              aria-disabled={!LIVE}
              target="_blank"
              rel="noreferrer noopener"
            >
              CHART
            </a>
          </div>
          <div className="web__hr" />
          <div className="web__panel web__panel--white buy__fine">
            <b>Fair launch · no presale · no wallet tax.</b> 1% creator tax + pons&apos; 1% base fee = 2% per trade. 1.7% of every trade is airdropped to holders as tokenized MSFT by pons, 0.3% goes to pons. The dev earns nothing from trading.
          </div>
          <div className="web__foot">Best viewed in Internet Explorer 6 at 800×600 · © 2001 Internet Coin · the internet pays dividends now (real)</div>
        </div>
      </div>
      <StatusBar>
        <span>Done</span>
        <span>Internet</span>
      </StatusBar>
    </Div>
  );
}

const Div = styled.div`
  ${xpCss};
  ${webCss};
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .xp__client {
    flex: 1;
    overflow: auto;
    padding: 0;
  }
  .buy__visitor {
    font-size: 10px;
    color: #fff3dc;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }
  .buy__ca {
    margin-bottom: 8px;
  }
  .buy__ca__row {
    margin-bottom: 4px;
  }
  .buy__small {
    font-size: 11px;
    padding: 4px 12px;
  }
  .buy__link {
    color: #0000ee;
    text-decoration: underline;
    cursor: pointer;
  }
  .buy__cta {
    display: flex;
    gap: 14px;
    justify-content: center;
    flex-wrap: wrap;
    margin: 4px 0 6px;
  }
  .buy__fine {
    font-size: 10.5px;
    line-height: 1.5;
    margin-bottom: 4px;
  }
  @media (max-width: 640px) {
    .web__cols {
      flex-direction: column;
    }
    .web__mast__right {
      display: none;
    }
  }
`;
